import { c as r } from "../../../../index.esm-BeDSGXP5.js";
import { css as a } from "styled-components";
const t = {
  primary: ({ theme: o }) => /* @__PURE__ */ a([
    "",
    ""
  ], r({
    background: o.componentColors.celebration.primary
  }))
};
export {
  t as default
};
